import { useMutation } from 'react-query'
import request from '../../request'
import { useDealership } from '../../../store/zustand/dealershipStore'

export default function useCheckSpreadsheetAccess() {
  const dealership = useDealership()

  return useMutation(
    ({
      service_email,
      spreadsheet_url,
    }: {
      service_email: string
      spreadsheet_url: string
    }) =>
      request({
        url: `/agencies/${dealership?.organization_id}/dealership/${dealership?.id}/utils/google_spreadsheet/check-access`,
        method: 'POST',
        data: {
          service_email,
          spreadsheet_url,
        },
      }),
  )
}
